import { render } from "./UploadFile.vue?vue&type=template&id=67d2948c&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=67d2948c&lang=less&scoped=true"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d2948c"]])

export default __exports__